var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "scroll-spy",
          rawName: "v-scroll-spy",
          value: { allowNoActive: true, offset: 300 },
          expression: "{allowNoActive: true, offset: 300}"
        }
      ],
      staticClass: "c-process-steps"
    },
    [
      _vm._l(_vm.processSteps, function(step, index) {
        return [
          _c(
            "process-step",
            _vm._b(
              {
                attrs: {
                  "process-id": _vm.processId,
                  index: index,
                  "process-type": _vm.processType,
                  sortIndexes: _vm.processSteps
                    .map(function(step) {
                      return step.sortIndex
                    })
                    .sort()
                },
                on: {
                  deleteProcessStep: _vm.deleteProcessStep,
                  editProcessStep: _vm.editProcessStep,
                  sortProcessStep: _vm.sortProcessStep,
                  publish: _vm.publishStep,
                  unpublish: _vm.unpublishStep
                }
              },
              "process-step",
              step,
              false
            )
          )
        ]
      }),
      _vm._v(" "),
      _c(
        "can",
        { attrs: { i: "manage", a: _vm.processType } },
        [
          !_vm.showCreate && _vm.processId !== "0"
            ? _c(
                "button",
                {
                  staticClass: "c-button c-button--primary t-margin-top-s",
                  on: { click: _vm.toggleShowCreate }
                },
                [_vm._v("Lägg till processteg")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCreate
            ? _c("process-step", {
                attrs: {
                  mode: "create",
                  "process-id": _vm.processId,
                  "process-type": _vm.processType
                },
                on: {
                  createProcessStep: _vm.createProcessStep,
                  toggleShowCreate: _vm.toggleShowCreate
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }